import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../../App.scss';
import Button from "../../Settings/Free/Button";

class QuestionOptions extends React.Component{
    constructor(props){
        super(props)
        this.state={
        }
    }
    render() {
        const {text,icon}=this.props.data
        const button={
            text:text,
            backgroundColor:'#C2B6C5',
            bottomFontSize:'15px',
            buttonTextColor:'#000000',
            borderColor:'#C2B6C5'
        }
        return(
            <Grid item container alignItems={"center"} sm={12} xs={12} justify={"center"} style={{backgroundColor:'#B3A4B6'}} className='question-option'>
                <Grid item container sm={10} xs={10} style={{height:'50px'}}>
                    <Button data={button}/>
                </Grid>
                <Grid item justify={"center"} alignItems={"center"} container sm={12} xs={12} className='question-option-selectable'>
                    <Grid container alignItems={"center"} style={{backgroundColor:'rgb(215, 246, 247)',width:'80%',height:'30px',borderRadius:'30px'}}>
                        <img src={icon} alt="" className='question-option-selectable-icon'/>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default QuestionOptions